import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import useStyles from "../../styles";
import { Grid, Typography, Card,  CardActions,CardActionArea, CardContent, Box, Dialog, IconButton,  CircularProgress, DialogActions as MuiDialogActions, DialogTitle as MuiDialogTitle } from "@material-ui/core";
import { PhoneDisabled as PhoneDisabledIcon, Close as CloseIcon, VolumeUp as VolumeUpIcon, VolumeOff as VolumeOffIcon, Mic as MicIcon, MicOff as MicOffIcon, TextRotationNone as TextRotationNoneIcon } from "@material-ui/icons";

// import AddCallIcon from "./AddCallIcon";
import Dot from "../../../../components/Sidebar/components/Dot";
//store
import * as actions from "../../../../store/actions/actionIndex";
// uitility function
import { maskedNumber, notify } from "../../../../helpers/utility";
import Dtmf from "../DTMF/Dtmf";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: 0,
        top: 0,
        color: theme.palette.grey[500],
    },
});


function CallParking(props) {
    var classes = useStyles();
    const [confCount, setConfCount] = useState(0);
    const [confAction, setConfAction] = useState("");
    const confStatusTimer = useRef(null);
   
    const confDisconnect = (agentId, channel) => {
        setConfAction(channel);
        props.onConfDisconnect(agentId, channel);
        clearTimeout(confStatusTimer);
        setTimeout(function() {
            setConfCount(confCount + 1);
        }, 1000);
    };

    return (
        <div className={classes.ConferenceCallConnect} container="true" spacing={1}>
            <Grid container spacing={1}>
               {props.confDetails && props.confDetails.length >= 2 ?
                    props.confDetails.map((option) => (
                        <Grid item xs={6} sm={3} key={option.cust_ph_no + option.chan_name}>
                            <Card className={classes.card}>
                                <CardContent>
                                    <div className={classes.CardTitle}>
                                        <Dot color={option.conf_leave === "1" ? "error" : "success"} style={{ textAlign: "start", width: "10%" }} />
                                        <Typography className={classes.CallStatusTitle} color="textSecondary" style={{ textAlign: "start", width: "40%" }}>
                                            {option.conf_leave === "1" ? "Disconnected" : "INCALL"}
                                        </Typography>
                                        <Typography className={classes.CallStatusTitle} color="textSecondary" style={{ textAlign: "end", marginLeft: "0px", width: "50%" }}>
                                            {"Conf Room " + option.confnum}
                                        </Typography>
                                    </div>
                                    <div className={classes.cardBody}>
                                        <Typography className={classes.CallNumber} color="textSecondary">
                                            <b>{option.cust_ph_no !== props.agentId ? (props.facilityConf.enable_number_mask ? (props.facilityConf.enable_number_mask === "1" ? maskedNumber(option.cust_ph_no, props.facilityConf.mask_start_pos, props.facilityConf.mask_end_pos) : option.cust_ph_no) : option.cust_ph_no) : props.agentId}</b>
                                        </Typography>
                                        <Typography className={classes.caller} color="textSecondary">
                                            {option.type}
                                            {/* {props.agentId === option.cust_ph_no ? "Agent" : "Customer"} */}
                                        </Typography>
                                    </div>
                                </CardContent>
                                <CardActions style={{ backgroundColor: "black", display: "flex", alignItems:"center", justifyContent: "center" }}>
                                    {/*<PlayPauseIcon />*/}
                                    {option.cust_ph_no !== props.agentId || props.callBack === "1" ? (
                                        <IconButton title="Hangup" style={{ color: "#aaa", padding: "0px", marginLeft: "12px" }} onClick={() => confDisconnect(props.agentId, option.chan_name)}>
                                            {props.loading && props.actionType === "confDisconnect" && confAction === "option.chan_name" ? <CircularProgress size={22} style={{ verticalAlign: "middle" }} /> : <PhoneDisabledIcon style={{ marginRight: "0px", marginLeft: "0px" }} />}
                                        </IconButton>
                                    ) : (
                                        <IconButton title="Hangup" style={{ color: "currentColor", padding: "0px", marginLeft: "12px" }}>
                                            <PhoneDisabledIcon style={{ marginRight: "0px", marginLeft: "0px" }} />
                                        </IconButton>
                                    )}
                                </CardActions>
                            </Card>
                        </Grid>
                    ))
                :
                
                <div
  style={{
    width: "100%",
  }}
>
  <Card
    className="data"
    style={{
      background: "#f6f7ff",
	  boxShadow: "none",
	  borderRadius: "10px"
    }}
  >
    <CardActionArea
      className={classes.AddCallActionArea}
      style={{
        padding: "0",
        margin: "0",
		gap: "10px"
      }}
    >
      <div>
        <Typography
          style={{
            fontSize: "16px",
            marginTop: "2px",
            color: "#6d6d80",
          }}
        >
      No parked call available for conference.
        </Typography>
      </div>
    </CardActionArea>
  </Card>
</div>
}
            </Grid>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        error: state.agentConf.error,
        loading: state.agentConf.loading,
      confDetails: state.callParking.confDetails,
      facilityConf: state.agentConfig.facilityConf,
      agentId: state.agentData.agentId,
       
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onParkCallData:(agentId) => dispatch(actions.parkCallStatus(agentId)),
        onGetConfDetails: (agentId) => dispatch(actions.getConfDetails(agentId)),
        onLeaveConf: (agentId) => dispatch(actions.leaveConf(agentId)),
        onJoinConf: (agentId, cond, confRoom, exten) => dispatch(actions.joinConf(agentId, cond, confRoom, exten)),
        onConfDisconnect: (agentId, channel) => dispatch(actions.confDisconnect(agentId, channel)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CallParking);
